import { render, staticRenderFns } from "./jzcgheader.vue?vue&type=template&id=6fb4c4d4&scoped=true&"
import script from "./jzcgheader.vue?vue&type=script&lang=js&"
export * from "./jzcgheader.vue?vue&type=script&lang=js&"
import style0 from "./jzcgheader.vue?vue&type=style&index=0&id=6fb4c4d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb4c4d4",
  null
  
)

export default component.exports